export enum PageLayout {
    Default = 'default',
    Center = 'center', // centered content, no frame
    Blank = 'blank', // no frame
    Checkout = 'checkout', // custom header
}
